import { Descriptions } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { useFeatureFlags } from "@/hooks/useUser"
import { IntroducedThroughUndetermined } from "@/molecules/IntroducedThroughUndetermined"
import {
  AiRelatedInsightContent,
  AiRelatedInsightLabel
} from "@/organisms/Drawers/components/AiRelatedInsight"
import { InsightsSbomCell } from "@/pages/DiscoveryPage/components/molecules/InsightsSbomCell"
import { EMPTY_VALUE, OverviewCardTemplate } from "../OverviewCardTemplate"

import styles from "@/organisms/Drawers/Drawers.module.scss"

export const InsightsCard = (props: any) => {
  const { t } = useTranslation()
  const { Label } = Descriptions
  const internetFacingFF = useFeatureFlags("internetFacingIntegration")
  const attr = { t, internetFacingFF }
  const tag = true
  const { data } = props

  if (!data) return null

  const { insights } = data
  const {
    isDirect,
    isIndirect,
    runtime,
    internetFacing,
    ingress,
    fromBaseImage,
    fromThirdParty,
    isDevDependency,
    aiRelated,
    aiPackageCategory
  } = insights
  const { exploitMaturity } = insights
  const cell = InsightsSbomCell(attr)

  const items = [
    {
      label: <Label>Introduced Through</Label>,
      className: styles.introducedThroughInsights,
      children:
        !isDirect && !isIndirect && !fromBaseImage && !fromThirdParty ? (
          <IntroducedThroughUndetermined />
        ) : (
          cell({ isDirect, isIndirect, fromBaseImage, fromThirdParty, tag })
        )
    },
    {
      label: <Label>Usage</Label>,
      children:
        runtime || isDevDependency
          ? cell({ runtime, isDevDependency, tag })
          : EMPTY_VALUE
    },
    {
      label: <Label>Exploit Maturity</Label>,
      children:
        exploitMaturity === "UNDETERMINED"
          ? EMPTY_VALUE
          : cell({
              "exploitability.POC": exploitMaturity === "POC",
              "exploitability.IN_THE_WILD": exploitMaturity === "IN_THE_WILD",
              tag
            })
    },
    {
      label: <Label>Exposure</Label>,
      children:
        !internetFacing && !ingress
          ? EMPTY_VALUE
          : cell({ internetFacing, ingress, tag })
    },
    {
      label: <AiRelatedInsightLabel />,
      children: (
        <AiRelatedInsightContent
          aiRelated={aiRelated}
          aiPackageCategory={aiPackageCategory}
        >
          {cell({ aiRelated, tag })}
        </AiRelatedInsightContent>
      )
    }
  ]

  return <OverviewCardTemplate title="Insights" items={items} />
}
